export default __webpack_public_path__ + "static/cli_dipac-b9ddebdebf1cdfbf650f2974f5491d86.png";